import { Col, ListGroupItem, Row } from 'reactstrap';
import { formatOffsetInTimeZone } from '@s20/common/util/date';
import { addSpacesToProperCase } from '@s20/common/util/string';
import { MomentDateFormat } from '../../Common';

export const propertyShouldNotBeDisplayed = (propertyChange) => propertyChange.property === 'Id';

const renderValue = (propertyChange, jsPropertyName, renderOptions) => {
    const rawValue = propertyChange[jsPropertyName];
    const propertyValue = renderOptions?.formatValue
        ? renderOptions.formatValue(propertyChange.property, rawValue)
        : rawValue;

    if (
        propertyValue
        && (propertyValue.startsWith('1/1/0001') || propertyValue.startsWith('0001-01-01'))) {
        return '';
    }

    if (!renderOptions) {
        return propertyValue;
    }

    if (
        propertyValue
        && renderOptions.formatOffset
        && propertyChange.propertyType.includes('DateTimeOffset')
    ) {
        return formatOffsetInTimeZone(propertyValue, MomentDateFormat.DateTimeShortAnte);
    }

    if (
        renderOptions.simpleDate
        && propertyValue
        && propertyChange.propertyType.includes('DateTime')
    ) {
        const propertyDate = new Date(propertyValue);

        return propertyDate.toLocaleDateString();
    }

    return propertyValue;
};
const getPropertyDisplayName = (property, renderOptions) =>
    renderOptions?.propertyDisplayNames?.[property] || addSpacesToProperCase(property);

const HistoryValue = ({ value }) => {
    if (value === null || value === undefined || value === '') {
        return <span className="text-muted">&mdash;</span>;
    }

    return value;
};

const getDisplayValues = (propertyChange, renderOptions) => ({
    property: getPropertyDisplayName(propertyChange.property, renderOptions),
    previousValue: renderValue(propertyChange, 'previousValue', renderOptions),
    newValue: renderValue(propertyChange, 'newValue', renderOptions),
});

const PropertyChange = (props) => {
    const { propertyChange, renderOptions } = props;

    if (!propertyChange || propertyShouldNotBeDisplayed(propertyChange)) {
        return null;
    }

    const { property, previousValue, newValue } = getDisplayValues(
        propertyChange,
        renderOptions,
    );

    return (
        <tr>
            <th
                className="fw-semibold text-break"
                scope="row"
            >
                {property}
            </th>
            <td className="text-muted text-break">
                <HistoryValue value={previousValue} />
            </td>
            <td className="text-success text-break">
                <HistoryValue value={newValue} />
            </td>
        </tr>
    );
};

export const PropertyChangeListItem = (props) => {
    const { propertyChange, renderOptions } = props;

    if (!propertyChange || propertyShouldNotBeDisplayed(propertyChange)) {
        return null;
    }

    const { property, previousValue, newValue } = getDisplayValues(
        propertyChange,
        renderOptions,
    );

    return (
        <ListGroupItem>
            <div className="border-bottom pb-2 mb-2 fw-bold text-break">
                {property}
            </div>
            <Row>
                <Col xs={6}>
                    <span className="d-block mb-1 text-uppercase text-muted">
                        Before
                    </span>
                    <span className="d-block text-muted text-break">
                        <HistoryValue value={previousValue} />
                    </span>
                </Col>
                <Col xs={6}>
                    <span className="d-block mb-1 text-uppercase text-muted">
                        After
                    </span>
                    <span className="d-block text-success text-break">
                        <HistoryValue value={newValue} />
                    </span>
                </Col>
            </Row>
        </ListGroupItem>
    );
};

export default PropertyChange;
